<template>
  <v-dialog
    v-model="dialog"
    width="400"
  >
    <v-card>
      <v-card-title>
        {{ $t('Edit media') }}
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="form.title"
          :loading="form.processing"
          :disabled="form.processing"
          :error-messages="errors.title"
          :label="$t('Title')"
          outlined
          autofocus
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="grey"
          text
          @click.native="cancel"
        >
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="form.processing"
          :loading="form.processing"
          @click="submit"
        >
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      upload: {
        type: Object,
        required: true
      },
      errors: {
        type: Object,
        default: () => ({}),
      }
    },

    data() {
      return {
        dialog: true,
        form: this.$inertia.form('EditMedia', {
          title: this.upload.title,
        })
      }
    },

    methods: {
      submit() {
        this.form.patch(this.route('media.update', this.upload.id).toString(), {
          onSuccess: () => this.form.reset()
        });
      },

      cancel() {
        return this.$inertia.visit(this.route('media.index'), {
          preserveState: true
        });
      }
    }
  }
</script>
